import type { ReactNode } from 'react';

import Icon from '../Icon';

import './StepSection.scss';

/** Пропсы секции шага StepSection. */
export interface StepSectionProps {
  /** номер шага — рисуется в кружке (при done — галочка) */
  step: number;
  /** заголовок шага */
  title: ReactNode;
  /** подпись-подсказка под заголовком */
  subtitle?: ReactNode;
  /** выбор сделан: галочка на зелёном вместо номера */
  done?: boolean;
  /** текущий шаг (ожидается клик): рамка $primary + мягкое кольцо + подложка */
  active?: boolean;
  /** бейджи-подтверждения под заголовком (CountBadge и т.п.) */
  badges?: ReactNode[];
  /** значение data-step корневого элемента — якорь для автоскролла к шагу */
  dataStep?: string | number;
  children?: ReactNode;
  className?: string;
}

/**
 * Секция нумерованного шага мастера: карточка с кружком-номером, заголовком
 * и подсказкой; активный шаг подсвечен рамкой с кольцом, пройденный —
 * галочкой на зелёном. Бейджи под заголовком подтверждают сделанный выбор.
 * Выделено из мастера ШМ (tfw-flow-section) в коллекцию ui.
 */
const StepSection = (props: StepSectionProps) => {
  const {
    step, title, subtitle, done, active,
    badges, dataStep, children, className,
  } = props;

  return (
    <div
      data-step={ dataStep }
      className={ [
        'step-section',
        active ? 'active' : '',
        className || '',
      ].filter(Boolean).join(' ') }
    >
      <div className='step-heading'>
        <span className={ done ? 'step-number done' : 'step-number' }>
          { done ? <Icon name='check' /> : step }
        </span>
        <div>
          <h6 className='mb-0'>{ title }</h6>
          { subtitle && <small className='text-muted'>{ subtitle }</small> }
        </div>
      </div>
      { badges && badges.length > 0 && (
        <div className='step-badges'>
          { badges }
        </div>
      ) }
      { children }
    </div>
  );
};

export default StepSection;
